import { useMemo } from 'react';
import { CLICK_TRACKING_EVENT, DATA_REASON, DATA_SUBFUNCTION, DATA_TYPE } from '../../../const/analytics';
import { getDataChannels, getDataMessage, getDeliveryChannels, getModifyDeliveryChannels, getPostFixData, hasUserEnrrolledInAnyDeliveryMethod } from './useButtonAnalyticsHelper';
var useButtonAnalytics = function (currentAlertData, alertFormData, hasConsentBanner) {
    return useMemo(function () {
        var TERMS_CONDITIONS_SAVE_BTN = DATA_REASON.SMS_BANNER.TERMS_CONDITIONS_SAVE_BTN;
        var SAVE_BTN_DATA_SUBFUNCTION = DATA_SUBFUNCTION.SMS_BANNER.TERMS_CONDITIONS_SAVE_BTN;
        if (hasConsentBanner) {
            return {
                dataFunction: '',
                dataSubFunction: "".concat(SAVE_BTN_DATA_SUBFUNCTION),
                dataName: 'complete',
                dataReason: "".concat(TERMS_CONDITIONS_SAVE_BTN),
                dataChannels: '',
                dataMessage: '',
                dataType: DATA_TYPE.BUTTON,
                alertName: '',
                dataAnalytics: CLICK_TRACKING_EVENT
            };
        }
        var alertId = currentAlertData.id, categoryId = currentAlertData.categoryId, isAlertOn = currentAlertData.isAlertOn, currentDeliveryMethods = currentAlertData.allDeliveryMethods;
        var dataErrors = alertFormData.dataErrors, formDeliveryMethods = alertFormData.delivery;
        var customAlertId = alertId.toLowerCase().replace(/_/g, ' ');
        var hasEnrrolled = hasUserEnrrolledInAnyDeliveryMethod(formDeliveryMethods);
        // Data Function
        var dataFunction = categoryId.toLowerCase();
        // Data SubFunction
        var subFunctionPostFix = getPostFixData(isAlertOn, hasEnrrolled, true);
        var dataSubFunction = "".concat(customAlertId, "|").concat(subFunctionPostFix);
        // Data Reason
        var reasonPostFix = getPostFixData(isAlertOn, hasEnrrolled);
        var dataReason = "".concat(customAlertId, ":").concat(reasonPostFix);
        // Data Channels
        var enrollDeliveryChannels = getDeliveryChannels(currentDeliveryMethods, formDeliveryMethods);
        var modifyDeliveryChannels = getModifyDeliveryChannels(currentDeliveryMethods, formDeliveryMethods);
        var dataChannels = getDataChannels(isAlertOn, hasEnrrolled, modifyDeliveryChannels, enrollDeliveryChannels);
        // Data Message
        var dataMessage = getDataMessage(hasEnrrolled, dataErrors);
        return {
            dataFunction: dataFunction,
            dataSubFunction: dataSubFunction,
            dataName: 'complete',
            dataReason: dataReason,
            dataChannels: dataChannels,
            dataMessage: dataMessage,
            dataType: DATA_TYPE.BUTTON,
            alertName: customAlertId,
            dataAnalytics: CLICK_TRACKING_EVENT
        };
    }, [currentAlertData, alertFormData, hasConsentBanner]);
};
export default useButtonAnalytics;
